import axios from '../../plugins/axios';
import { DIRECTION_TYPE } from '../../vars';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {
            trip: null,
            directionType: DIRECTION_TYPE.RUSSIA,
            approveCount: 0,
            approveDays: 0,
            prepaymentPercent: 0,
            prepaymentDays: 0,
            cancelFullDays: 0,
            cancelHalfDays: 0,
            endOfBookingDays: 0,
        }
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {
                trip: null,
                directionType: DIRECTION_TYPE.RUSSIA,
                approveCount: 0,
                approveDays: 0,
                prepaymentPercent: 0,
                prepaymentDays: 0,
                cancelFullDays: 0,
                cancelHalfDays: 0,
                endOfBookingDays: 0,
            };
        },
    },

    actions: {
        async fetch({ commit }, { filter = {}, sorting = null }) {
            const { data } = await axios.get('/admin/booking-settings', { params: { filter, sorting } });
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { id }) {
            const { data } = await axios.get(`/admin/booking-settings/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }) {
            let response = {};
            if(state.entity._id) {
                response = await axios.put(`/admin/booking-settings/${ state.entity._id }`, state.entity);
            } else {
                response = await axios.post('/admin/booking-settings', state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { id }) {
            await axios.delete(`/admin/booking-settings/${ id }`);
        },
    },

    getters: {}
}
